import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/app/(core)/ib/[subject]/(withSyllabusBar)/notes/[topic]/components/NoteLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/app/(core)/ib/[subject]/components/header/SubjectHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/app/(core)/ib/[subject]/components/SubjectContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/ApartmentRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/ContactPageRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/EngineeringRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/HourglassBottomRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/HourglassDisabledRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/LocalPoliceRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/SchoolRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/SupervisorAccountRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/WarningRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/@mui/icons-material/WhatshotRounded.js");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/katex/dist/katex.min.css");
